export default __webpack_public_path__ + "static/Category5-74f43dae83041f048c54bef22aece8e2.jpg";